import React from 'react';

function Uganda(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_123970)">
        <mask
          id="mask0_800_123970"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_123970)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#FECA00"
          />
          <mask
            id="mask1_800_123970"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_123970)">
            <rect width="36" height="4" fill="#272727" />
            <rect y="8" width="36" height="4" fill="#D74800" />
            <rect y="12" width="36" height="4" fill="#272727" />
            <rect y="20" width="36" height="4" fill="#D74800" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18 18C21.7279 18 24.75 15.3137 24.75 12C24.75 8.68629 21.7279 6 18 6C14.2721 6 11.25 8.68629 11.25 12C11.25 15.3137 14.2721 18 18 18Z"
              fill="#F7FCFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15.3895 8.32864L14.1993 8.67579L15.3895 8.76637C15.3895 8.76637 15.582 9.18472 15.3895 9.5113C15.3407 9.59421 15.2147 9.70043 15.0538 9.83601C14.5811 10.2345 13.8074 10.8867 13.8074 11.9462C13.8074 13.3663 16.8905 14.0102 16.8905 14.0102V14.6849C16.8905 14.6849 17.2484 14.8824 15.2067 14.8824C13.4362 14.8824 13.5469 15.4799 13.6075 15.8069C13.6168 15.857 13.6249 15.9008 13.6249 15.935C13.6249 16.1933 14.4759 15.6768 14.8743 15.1626C15.084 14.892 15.9621 14.9063 16.8634 14.9805C16.9345 14.9864 17.5916 16.2237 17.0212 16.8629C16.7815 17.1314 15.9539 17.1664 15.4368 17.1883C15.1731 17.1994 14.9902 17.2071 15.0072 17.2407C15.0199 17.2658 15.1758 17.2576 15.4025 17.2455C15.6854 17.2305 16.0784 17.2097 16.4407 17.2407C16.4957 17.2454 16.2825 17.4099 16.0669 17.5762C15.8449 17.7475 15.6204 17.9207 15.6836 17.9234C15.7547 17.9263 16.1705 17.7216 16.5482 17.5356C16.8607 17.3817 17.1472 17.2407 17.1909 17.2407C17.4759 17.2407 17.7333 17.2719 17.959 17.2994C18.3364 17.3452 18.6253 17.3803 18.8072 17.2407C18.8632 17.1977 18.5385 17.1285 18.2073 17.058C17.8662 16.9854 17.5183 16.9113 17.5731 16.8629C17.8867 16.5863 17.7557 16.0064 17.6525 15.5498C17.6062 15.3449 17.5655 15.1648 17.5731 15.048C17.5999 14.6332 18.0935 14.8508 18.4814 15.0218C18.6513 15.0967 18.8009 15.1626 18.8822 15.1626C19.6168 15.1626 18.7046 14.3367 18.204 13.8834C18.1601 13.8437 18.1194 13.8068 18.0832 13.7736C17.8286 13.5399 18.0072 13.5713 18.4109 13.6423C18.7189 13.6964 19.1581 13.7736 19.6357 13.7736C20.7393 13.7736 21.5448 13.4549 21.265 12.592C21.0804 12.0227 20.0696 11.829 19.0136 11.6266C18.469 11.5222 17.9123 11.4155 17.4507 11.2538C16.3151 10.8559 16.373 10.2758 16.422 9.78534C16.4315 9.68994 16.4407 9.59793 16.4407 9.5113C16.4407 8.97929 17.4507 8.32864 17.4507 8.32864C17.4507 8.32864 16.9898 7.64209 16.2254 7.64209C15.4609 7.64209 15.3895 8.32864 15.3895 8.32864ZM17.4688 14.5765V14.0747C17.4688 14.0747 17.9408 14.0609 18.1064 14.4139C18.2719 14.7668 17.4688 14.5765 17.4688 14.5765Z"
              fill="#272727"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14.7114 6.71128L15.8517 7.91322L16.4422 7.78976L16.159 6.57642L14.7114 6.71128Z"
              fill="#D74800"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16.192 6.42064L16.2655 8.22769L17.2392 8.01473L17.6538 6.83122L16.192 6.42064Z"
              fill="#FFD018"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15.2742 9.43892C15.4893 9.43892 15.6636 9.28781 15.6636 9.10142C15.6636 8.91502 15.4893 8.76392 15.2742 8.76392C15.0591 8.76392 14.8848 8.91502 14.8848 9.10142C14.8848 9.28781 15.0591 9.43892 15.2742 9.43892Z"
              fill="#D74800"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17.7485 6.7592L16.6149 7.96608L16.8542 8.46156L18.1493 8.00296L17.7485 6.7592Z"
              fill="#D74800"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M20.3837 15.8931C20.3837 15.8931 22.3777 15.1013 22.3777 13.994C22.3777 12.8867 19.1399 11.6805 19.1399 11.6805C19.1399 11.6805 17.2354 12.068 18.0939 12.5865C18.9523 13.105 20.1024 13.3042 20.1024 13.994C20.1024 14.6838 20.4175 15.3415 19.7787 15.3415C19.1399 15.3415 20.3837 15.8931 20.3837 15.8931Z"
              fill="#D74800"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17.5068 11.4781C17.5068 11.4781 16.8015 11.5883 16.835 11.6901C16.9276 11.9716 17.8919 12.3382 18.3121 12.592C19.1706 13.1105 19.9845 13.0523 20.59 12.7148C21.1954 12.3774 17.5068 11.4781 17.5068 11.4781Z"
              fill="#FFFDFF"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_123970">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Uganda;
